import { ZirpApiClient } from "@zirp/client";
import { config as c } from "~~/config";
export default defineNuxtPlugin(() => {
  const domain = c.API_DOMAIN;
  const baseUrl = "https://api.zirp.dev";

  const api = new ZirpApiClient({
    BASE: baseUrl,
    WITH_CREDENTIALS: false,
    CREDENTIALS: "omit",
  });

  return {
    provide: {
      api,
    },
  };
});
